import React from 'react';
import { useSuggestionsPillsContext } from '../context/SuggestionsPillsContext';
import { Suggestion } from './Suggestion';

export const Suggestions = () => {
    const { suggestions } = useSuggestionsPillsContext();

    return (
        <>
            {suggestions?.map(([[filter, slug]]) => {
                return (
                    <Suggestion
                        key={`${filter}-${slug}`}
                        modifiers={[filter, slug]}
                    />
                );
            })}
        </>
    );
};
